import React from "react"

import Layout from "../components/layout"
import "../components/index.css"
import SEO from "../components/seo"
import MainPage from "../components/mainpage"
import LayoutMobile from "../components/layoutMobile"
import LayoutSmall from "../components/layoutSmall"

class IndexPage extends React.Component {


  state = {width:1600}

  componentDidMount() {
    this.setState({width : innerWidth})
  }


  render(){
    if (this.state.width < 950) {
      console.log("Mobile Index")


      return(
        <LayoutMobile>
          <SEO title="KlimaLeaks" />
          <p>
            <MainPage/>
          </p>
        </LayoutMobile>
      )
    }

    if (this.state.width < 1200){
      console.log("Small Index")


      return(
        <LayoutSmall>
          <SEO title="KlimaLeaks" />
          <p>
            <MainPage/>
          </p>
        </LayoutSmall>
      )
    }



    console.log("Desktop Index")

    return(
      <Layout>
        <SEO title="KlimaLeaks" />
        <p>
          <MainPage/>
        </p>
      </Layout>
    )
  }
}

export default IndexPage
